import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { WarehouseExportService } from 'src/app/services/inventory-warehouse/warehouse-export.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-warehouse-reports',
  templateUrl: './warehouse-reports.component.html',
  styleUrls: ['./warehouse-reports.component.scss']
})
export class WarehouseReportsComponent {
  uuid: string | null = '';

  reportForm: FormGroup = this.fb.group({
    customerUuid: ['']
  });

  customers: any[] = [];
  filteredCustomers: any[] = [];
  customerSearchCtrl = new FormControl('');

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private http: HttpClient,
    private wes: WarehouseExportService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');
      if (this.uuid) {
        this.loadWarehouseCustomers(this.uuid);
      }
    });

    this.customerSearchCtrl.valueChanges.subscribe(search => {
      const term = (search || '').toLowerCase();
      this.filteredCustomers = this.customers.filter(c =>
        c.inventory_warehouse_customer_name.toLowerCase().includes(term)
      );
    });
  }

  // Load warehouse customers
  loadWarehouseCustomers(warehouseUuid: string): void {
    this.http
      .get<any[]>(`/api/inventory/inventory_warehouse_customers.php?uuid=${warehouseUuid}`)
      .subscribe({
        next: data => {
          this.customers = data || [];
          this.filteredCustomers = this.customers;
        },
        error: err => {
          console.error(err);
          this.toastr.error('Failed to load warehouse customers');
        }
      });
  }

  // Internal CSV
  createInternalCSV(): void {
    if (!this.uuid) {
      this.toastr.error('Missing warehouse ID.');
      return;
    }

    this.toastr.info('Generating internal CSV report...', 'Please wait');
    this.wes.downloadCsv('contact_spots_used', this.uuid);
    this.toastr.success('Internal report is downloading', 'Success');
  }

  // External CSV
  createExternalCSV(): void {
    const warehouseUuid = this.uuid;
    const customerUuid = this.reportForm.get('customerUuid')?.value;
    console.log(`warehouse: ${warehouseUuid} | customer: ${customerUuid}`);

    if (!warehouseUuid) {
      this.toastr.error('Missing warehouse UUID.');
      return;
    }

    if (!customerUuid) {
      this.toastr.error('Select a customer first!');
      return;
    }

    this.toastr.info('Generating customer CSV report...', 'Please wait');
    this.wes.downloadCsv('customer_positions', warehouseUuid, customerUuid, 'Customer_Report');
    this.toastr.success('Customer report is downloading', 'Success');
  }
}
